export { renderBreadcrumb_unstable as renderBreadcrumb } from '@fluentui/react-breadcrumb';
